import { PROGRESS_CAPSULE_RESERVE_PX } from "../components/ChapterProgress/capsuleLayout";

export const READER_MAX_WIDTH = "2200px";

export const SELECTION_DOCK_RESERVE_PX = { xs: 280, sm: 240 };

export { PROGRESS_CAPSULE_RESERVE_PX };

export const getReaderBottomReserve = ({ hasSelection = false } = {}) => ({
  xs: `${Math.max(
    hasSelection ? SELECTION_DOCK_RESERVE_PX.xs : 0,
    PROGRESS_CAPSULE_RESERVE_PX.xs
  )}px`,
  sm: `${Math.max(
    hasSelection ? SELECTION_DOCK_RESERVE_PX.sm : 0,
    PROGRESS_CAPSULE_RESERVE_PX.sm
  )}px`,
});

export const isRectCoveredBySelectionDock = (
  rect,
  { viewportHeight, isMobile = false, topChromePx = 64 } = {}
) => {
  if (!rect || !viewportHeight) return false;
  const reserve = isMobile
    ? SELECTION_DOCK_RESERVE_PX.xs
    : SELECTION_DOCK_RESERVE_PX.sm;
  return rect.bottom > viewportHeight - reserve || rect.top < topChromePx;
};

export const revealElementAboveSelectionDock = (
  node,
  { isMobile = false } = {}
) => {
  if (!node || typeof window === "undefined") return false;
  const rect = node.getBoundingClientRect();
  if (
    !isRectCoveredBySelectionDock(rect, {
      viewportHeight: window.innerHeight,
      isMobile,
    })
  ) {
    return false;
  }
  node.scrollIntoView({ block: "center", behavior: "smooth" });
  return true;
};

export const getReaderContainerSx = (
  contentWidth,
  { hasSelection = false } = {}
) => ({
  width: { xs: "100%", md: `${contentWidth}%` },
  maxWidth: READER_MAX_WIDTH,
  mx: "auto",
  py: { xs: 0, sm: 2, md: 3 },
  px: { xs: 0, sm: 3, md: 4 },
  pb: getReaderBottomReserve({ hasSelection }),
  transition: "width 220ms ease",
});

export const readerChapterChipSx = {
  fontWeight: 600,
  fontSize: { xs: "0.75rem", sm: "0.82rem" },
  height: "auto",
  minHeight: { xs: 24, sm: 26 },
  maxWidth: "100%",
  bgcolor: (theme) =>
    theme.palette.mode === "dark"
      ? "rgba(226, 196, 138, 0.08)"
      : "rgba(196, 162, 101, 0.1)",
  borderColor: "primary.main",
  "& .MuiChip-label": {
    display: "block",
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "clip",
    py: 0.25,
    lineHeight: 1.35,
  },
};

export const readerPaperSx = {
  p: { xs: 2, sm: 3, md: 6 },
  borderRadius: { xs: 0, sm: 4 },
  border: "1px solid",
  borderColor: "divider",
  bgcolor: "background.paper",
  color: "text.primary",
  boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
  transition: "background-color 200ms ease, color 200ms ease",
};

export const READER_RAIL_WIDTH_PX = 52;

export const getReaderPaperWithRailsSx = (contentWidth = 80) => ({
  ...readerPaperSx,
  mx: {
    xs: 0,
    md: Number(contentWidth) > 88 ? `${READER_RAIL_WIDTH_PX - 8}px` : 0,
  },
});

export const getReaderRailPositionSx = (
  side = "left",
  contentWidth = 80,
  { isZenMode = false } = {}
) => {
  const safeWidth = Math.min(100, Math.max(50, Number(contentWidth) || 80));
  const edgeOffset = `max(8px, calc((100vw - ${safeWidth}vw) / 2 - 28px))`;

  return {
    display: { xs: "none", md: "flex" },
    flexDirection: "column",
    alignItems: "center",
    gap: 0.75,
    position: "fixed",
    zIndex: 1180,
    width: READER_RAIL_WIDTH_PX,
    p: 0.75,
    borderRadius: 3,
    bgcolor: (theme) =>
      theme.palette.mode === "dark"
        ? "rgba(22, 27, 34, 0.88)"
        : "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(12px)",
    border: "1px solid",
    borderColor: "divider",
    boxShadow: "0 6px 24px rgba(0, 0, 0, 0.08)",
    ...(side === "left"
      ? { left: edgeOffset, top: 108 }
      : { right: edgeOffset, top: "50%", transform: "translateY(-50%)" }),
    opacity: isZenMode ? 0.08 : 1,
    transition:
      "opacity 200ms ease, left 220ms ease, right 220ms ease, background-color 200ms ease",
    "&:hover, &:focus-within": {
      opacity: 1,
    },
  };
};
